<template>
    <BlockContainer
        :id="'article-' + slugify(article.title)"
        background-color="white"
        divider-arrow-class="left-[50%] bottom-6"
        slot-class="py-12 md:py-28"
    >
        <div class="gap-x-6 md:flex">
            <div class="md:w-1/4">
                <div class="mb-4 text-xl font-bold">Table of Contents</div>
                <div class="flex flex-col">
                    <a
                        v-for="section in articleContentSections"
                        :key="slugify(section.id)"
                        :href="'#' + slugify(section.id)"
                        class="flex justify-between border-b border-gray-300 py-4 text-grind no-underline"
                    >
                        <h4>{{ section.heading }}</h4>
                        <Icon name="arrow-down-solid" class="text-xl" />
                    </a>
                </div>
                <ArticleCta
                    v-if="article.showCta"
                    class="mt-6 hidden md:block"
                    :link-url="urlFromStoryblokLinkField(article.ctaLink)"
                    :link-label="article.ctaLink ? article.ctaLink.label : ''"
                    :text="article.ctaText ? article.ctaText : ''"
                    :heading="article.ctaHeading ? article.ctaHeading : ''"
                />
            </div>
            <div class="mt-12 md:mt-0 md:w-3/4">
                <h2 class="mb-6">{{ article.subtitle }}</h2>
                <WysiwygContent :content="article.description" class="mb-6" />

                <div
                    v-for="section in article.sections"
                    :id="slugify(section.id)"
                    :key="slugify(section.id)"
                >
                    <ArticleContentSection
                        v-if="section.type === 'article_content_section'"
                        v-editable="section.vEditable"
                        :section="section"
                    />
                    <ArticleTestimonialSection
                        v-if="section.type === 'customer_testimonial'"
                        v-editable="section.vEditable"
                        :section="section"
                    />
                </div>
                <ArticleCta
                    v-if="article.showCta"
                    class="mt-6 md:hidden"
                    :link-url="article.ctaLink ? article.ctaLink.url : ''"
                    :link-label="article.ctaLink ? article.ctaLink.label : ''"
                    :text="article.ctaText ? article.ctaText : ''"
                    :heading="article.ctaHeading ? article.ctaHeading : ''"
                />
            </div>
        </div>
    </BlockContainer>
</template>

<script setup lang="ts">
import type { ArticleType } from '#shared/types/ArticleType';
import ArticleContentSection from '~/components/page-building/article/ArticleContentSection.vue';
import ArticleCta from '~/components/page-building/article/ArticleCta.vue';
import ArticleTestimonialSection from '~/components/page-building/article/ArticleTestimonialSection.vue';
import { urlFromStoryblokLinkField } from '~/utils/helpers';

const props = defineProps<{
    article: ArticleType;
}>();

const articleContentSections = computed(() => {
    return props.article.sections.filter(
        (section) => section.type === 'article_content_section',
    );
});
</script>
